const middleware = {}

middleware['auth-external'] = require('../middleware/auth-external.ts')
middleware['auth-external'] = middleware['auth-external'].default || middleware['auth-external']

middleware['facebook-sale-cookie-check'] = require('../middleware/facebook-sale-cookie-check.ts')
middleware['facebook-sale-cookie-check'] = middleware['facebook-sale-cookie-check'].default || middleware['facebook-sale-cookie-check']

middleware['guard'] = require('../middleware/guard.ts')
middleware['guard'] = middleware['guard'].default || middleware['guard']

middleware['init-store'] = require('../middleware/init-store.ts')
middleware['init-store'] = middleware['init-store'].default || middleware['init-store']

middleware['redirect'] = require('../middleware/redirect.ts')
middleware['redirect'] = middleware['redirect'].default || middleware['redirect']

middleware['retain-referer'] = require('../middleware/retain-referer.ts')
middleware['retain-referer'] = middleware['retain-referer'].default || middleware['retain-referer']

export default middleware
